import ReactDOM from "react-dom";

const Modal = ({ children }) => {
  return ReactDOM.createPortal(
    <div className="modal-overlay" >
      <div className="chat-modal-content" >
        {children}
      </div>
    </div>,
    document.body
  );
};

export default Modal;
